<template>
  <v-app id="inspire">
    <Sidebar />
    <Header />
    <v-content>
      <message-component></message-component>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
    <small v-if="env != 'production'">{{title}}:{{env}}:{{baseUrl}}</small>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import MessageComponent from "@/components/common/MessageComponent.vue";
import layouts from "@/components/layout/";
import setupInterceptor from "./config/interceptorsConfig.js";

export default {
  components: {
    ...layouts,
    MessageComponent
  },
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    env: process.env.NODE_ENV,
    baseUrl: process.env.VUE_APP_BASE_URL,
    title: process.env.VUE_APP_TITLE
  }),
  methods: {
    ...mapActions(["appLoading"])
  },
  created: function() {
    setupInterceptor(this.$axios, this.$store, this.$router);
  }
};
</script>
